import bannerImg from './banners/woman-helping-man-gym.jpg';

export default {
    id: 'acompanhamento-nutricional',
    title: 'Acompanhamento nutricional semanal',
    description: 'Check-in semanal para monitorar a adesão ao plano alimentar, dificuldades e evolução do peso.',
    indicatedFor: 'Nutricionistas',
    stepsCount: 1,
    questionsSummary: ['Adesão ao plano', 'Peso da semana', 'Dificuldades', 'Energia e disposição'],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: 'Acompanhamento nutricional semanal',
        active: false,
        allow_multiple_answers: true,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Check-in da semana',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Enviar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'scale',
                        label: 'De 1 a 5, como foi sua adesão ao plano alimentar esta semana?',
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: 'Muito ruim',
                            maxLabel: 'Perfeita',
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 2,
                        type: 'weight',
                        label: 'Qual é o seu peso hoje?',
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'text',
                        label: 'Teve alguma dificuldade para seguir o plano? Descreva.',
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'scale',
                        label: 'Como você avalia seu nível de energia e disposição esta semana?',
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: 'Muito baixo',
                            maxLabel: 'Excelente',
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                ],
            },
        ],
        actions: [],
    },
};
